import { render, staticRenderFns } from "./ContentLoaderAdaptivePricingCurrency.vue?vue&type=template&id=2d1a37c0&"
import script from "./ContentLoaderAdaptivePricingCurrency.vue?vue&type=script&lang=js&"
export * from "./ContentLoaderAdaptivePricingCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports